export enum DiagnosticSteps {
  DEMONSTRATE = 0,
  ASSESSMENT = 1,
  FINISHED = 2,
}

export const WIDTH_RESIZE_BREAKPOINT = 1124;
